/** English of the interface (ADR 0069), keyed by the exact French phrase. See `index.ts`. */
export const SOCIAL: Readonly<Record<string, string>> = {
  // net/account.ts
  'Serveur injoignable. Il tourne bien ?': 'Server unreachable. Is it running?',
  'Action refusée': 'Action refused',
  'Réponse du serveur inattendue': 'Unexpected server response',
  // net/session.ts
  'Connexion refusée': 'Sign-in refused',
  // net/sign-in.ts
  'Connexion annulée.': 'Sign-in canceled.',
  'Connexion impossible.': 'Could not sign in.',
  // scenes/boot-scene.ts
  Connexion: 'Connecting',
  // scenes/world-scene.ts
  'Écouter ses conseils': 'Hear his advice',
  'Voir la forge': 'See the forge',
  'Voir les runes': 'See the runes',
  'Voir la boutique': 'See the shop',
  'Voir la fonderie': 'See the smelter',
  'Voir les potions': 'See the potions',
  'Objet introuvable.': 'Item not found.',
  'Cet objet ne s’équipe pas.': 'This item cannot be equipped.',
  'Ton niveau est trop bas pour cet objet.': 'Your level is too low for this item.',
  'Cet objet est réservé à une autre classe.': 'This item is for another class.',
  'Ton sac est plein.': 'Your Bag is full.',
  'Cet objet ne s’utilise pas.': 'This item cannot be used.',
  'Ta vie est déjà au maximum.': 'Your health is already full.',
  'Aucune de tes quêtes ne demande cette créature pour l’instant.':
    'None of your Quests needs this creature right now.',
  'Pose l’appât près d’un terrier, hors du village.':
    'Lay the bait near a den, outside the village.',
  'Ta proie est déjà sortie : abats-la d’abord.': 'Your prey is already out: bring it down first.',
  'Termine d’abord ton échange.': 'Finish your trade first.',
  'Une quête en cours te l’a confié : abandonne-la ou rends-la d’abord.':
    'A quest under way lent it to you: abandon it or turn it in first.',
  'Action invalide.': 'Invalid action.',
  'Sort inconnu.': 'Unknown Spell.',
  'Ce sort n’est pas de ta classe.': 'This Spell is not of your class.',
  'Ce sort n’est pas encore prêt.': 'This Spell is not ready yet.',
  'Pas assez d’énergie.': 'Not enough Energy.',
  'Attaque d’abord un ennemi.': 'Attack an enemy first.',
  'Ta cible est trop loin.': 'Your target is too far away.',
  'Tu es à terre.': 'You are down.',
  'Descends de ta monture pour combattre ({key}).': 'Get off your Mount to fight ({key}).',
  'Tu ne connais pas encore ce sort.': 'You do not know this Spell yet.',
  'Ce sort n’est pas dans ta barre.': 'This Spell is not on your bar.',
  'Pas de place pour charger.': 'No room to charge.',
  'Descends de ta monture pour combattre.': 'Get off your Mount to fight.',
  'Session ouverte ailleurs': 'Session opened elsewhere',
  'Connexion perdue. Retour en jeu dès que possible…':
    'Connection lost. Back in the game as soon as possible…',
  'Déconnecté du serveur': 'Disconnected from the server',
  'Mise à jour du serveur. Retour en jeu dès qu’il revient…':
    'Server update. Back in the game as soon as it returns…',
  'Redémarrage du serveur dans {seconds} s': 'Server restarting in {seconds} s',
  'Mise à jour': 'Update',
  'Le serveur redémarre pour une mise à jour : retour en jeu dans quelques instants.':
    'The server is restarting for an update: back in the game in a few moments.',
  'Zone « {zone} » inconnue': 'Unknown zone “{zone}”',
  'Connexion…': 'Connecting…',
  'Portail de {name} activé : tu peux y revenir de partout.':
    '{name} Portal activated: you can come back to it from anywhere.',
  'Tu te relèveras désormais à {name}.': 'From now on you will rise again at {name}.',
  'Te voici à {name} ({cost} or).': 'Here you are in {name} ({cost} gold).',
  'Approche-toi de la porte de l’hôtel des ventes.': 'Get closer to the Auction House door.',
  'Admin : F2 ouvre l’éditeur de carte, F3 le panneau MJ, un clic sur la carte (M) t’y téléporte.':
    'Admin: F2 opens the map editor, F3 the GM panel, a click on the map (M) teleports you there.',
  'Événement lancé.': 'Event started.',
  'Événement arrêté.': 'Event stopped.',
  'Un événement est déjà en cours.': 'An event is already under way.',
  'Aucun événement ici.': 'No event here.',
  "Le coffre s'ouvre et laisse tomber : {items}.": 'The Chest opens and drops: {items}.',
  'Le coffre est enchaîné : il faut d’abord nettoyer le camp avec ceux qui le gardent.':
    'The Chest is chained: first clear the Camp of those who guard it.',
  'Ce coffre est vide pour l’instant.': 'This Chest is empty for now.',
  'Approche-toi du coffre.': 'Get closer to the Chest.',
  'Les morts n’ouvrent pas de coffre.': 'The dead do not open Chests.',
  'Tu passes au niveau {level} !': 'You reach Level {level}!',
  'NIVEAU {level}': 'LEVEL {level}',
  'Connexion perdue. Reconnexion…': 'Connection lost. Reconnecting…',
  'Tu es tombé…': 'You have fallen…',
  'Tu es tombé. Tu perds {xp} XP. Tu te relèves au sanctuaire.':
    'You have fallen. You lose {xp} XP. You rise again at the shrine.',
  'Tu es tombé. Tu te relèves au sanctuaire.': 'You have fallen. You rise again at the shrine.',
  'Tu es tombé. Tu perds {xp} XP. Tu te relèves au portail de {portal}.':
    'You have fallen. You lose {xp} XP. You rise again at the {portal} Portal.',
  'Tu es tombé. Tu te relèves au portail de {portal}.':
    'You have fallen. You rise again at the {portal} Portal.',
  'A MOI !': 'TO ME!',
  'RAGE !': 'RAGE!',
  'Nouveau sort : {name}': 'New Spell: {name}',
  'Session expirée. Recharge la page.': 'Session expired. Reload the page.',
  'Connexion impossible. Le serveur tourne ?': 'Cannot connect. Is the server running?',
  'L’hôtel des ventes est fermé.': 'The Auction House is closed.',
  'Équipe d’abord une monture.': 'Equip a Mount first.',
  'Pas de monture en plein combat.': 'No Mount in the middle of a fight.',
  'Hôtel des ventes indisponible.': 'Auction House unavailable.',
  'L’hôtel des ventes ne répond pas.': 'The Auction House is not responding.',
  'Ce coffre est vide.': 'This Chest is empty.',
  'Les gobelins attaquent le village : personne ne sert tant qu’ils sont là !':
    'Goblins are attacking the village: no one serves while they are here!',
  'Tu entres : {place}': 'You enter: {place}',
  'Tu entres : {place} ({level})': 'You enter: {place} ({level})',
  // settings/keybindings.ts
  Inventaire: 'Inventory',
  'Carte du monde': 'World Map',
  Portails: 'Portals',
  Profil: 'Profile',
  Succès: 'Achievements',
  'Journal de quêtes': 'Quest Journal',
  Grimoire: 'Spellbook',
  Réglages: 'Settings',
  Boutique: 'Shop',
  Amis: 'Friends',
  Guilde: 'Guild',
  Classement: 'Leaderboard',
  'Hôtel des ventes (ancien raccourci)': 'Auction House (old shortcut)',
  'Monter / descendre': 'Mount / dismount',
  'Boire une potion de vie': 'Drink a health potion',
  'Cibler / attaquer': 'Target / attack',
  'Cible suivante': 'Next target',
  Interagir: 'Interact',
  'Sort 1': 'Spell 1',
  'Sort 2': 'Spell 2',
  'Sort 3': 'Spell 3',
  'Sort 4': 'Spell 4',
  'Marcher vers le haut': 'Walk up',
  'Marcher vers le bas': 'Walk down',
  'Marcher vers la gauche': 'Walk left',
  'Marcher vers la droite': 'Walk right',
  Espace: 'Space',
  'key|Retour': 'Backspace',
  Suppr: 'Del',
  Haut: 'Up',
  Bas: 'Down',
  'key|Gauche': 'Left',
  Droite: 'Right',
  Début: 'Home',
  Fin: 'End',
  'Page haut': 'Page Up',
  'Page bas': 'Page Down',
  Inser: 'Ins',
  'Verr. maj': 'Caps Lock',
  'Souris 4': 'Mouse 4',
  'Souris 5': 'Mouse 5',
  '{label} ({key})': '{label} ({key})',
  // ui/chat-commands.ts
  '/general, /z, /g, /gu : parler à tous, à la zone, au groupe, à la guilde · /m nom message : message privé · /r : répondre · /inviter nom · /quitter · /exclure nom · /ami nom · /echanger nom · /signaler nom · /bloquer nom · /debloquer nom · /absent · /guilde inviter|exclure|promouvoir|retrograder nom, /guilde devise texte, /guilde quitter, /guilde dissoudre':
    '/general, /z, /g, /gu: talk to everyone, the Zone, the Party, the Guild · /m name message: Whisper · /r: reply · /inviter name · /quitter · /exclure name · /ami name · /echanger name · /signaler name · /bloquer name · /debloquer name · /absent · /guilde inviter|exclure|promouvoir|retrograder name, /guilde devise text, /guilde quitter, /guilde dissoudre',
  '/mute nom [minutes] [raison] · /unmute nom · /kick nom [raison] · /ban nom [jours] [raison] · /unban nom · /event prairie|foret|marais|desert|neige · /event stop':
    '/mute name [minutes] [reason] · /unmute name · /kick name [reason] · /ban name [days] [reason] · /unban name · /event prairie|foret|marais|desert|neige · /event stop',
  // ui/chat.ts
  Chat: 'Chat',
  'Écris un message': 'Write a message',
  'Entrée pour parler': 'Enter to talk',
  Message: 'Message',
  Envoyer: 'Send',
  Tout: 'All',
  Général: 'General',
  Zone: 'Zone',
  Groupe: 'Party',
  Privé: 'Whisper',
  'À {name}': 'To {name}',
  De: 'From',
  "Tu n'es pas dans un groupe.": 'You are not in a Party.',
  "Tu n'es pas dans une guilde.": 'You are not in a Guild.',
  'Tu es réduit au silence encore {minutes} min.': 'You are muted for {minutes} more min.',
  "Personne de ce nom n'est en jeu.": 'No one by that name is in the game.',
  'Tu parles trop vite. Réessaie dans {seconds} s.':
    'You are talking too fast. Try again in {seconds} s.',
  'Message refusé.': 'Message refused.',
  'Trois objets au plus par message.': 'Three items at most per message.',
  "Cet objet n'est plus à toi.": 'That item is no longer yours.',
  // ui/discord.ts
  'Rejoindre le Discord': 'Join the Discord',
  // ui/friends-panel.ts
  'Fermer (Échap)': 'Close (Esc)',
  'Nom du joueur': 'Player name',
  'Nom du joueur à ajouter': 'Name of the player to add',
  Ajouter: 'Add',
  'Amis ({online} en ligne sur {total})': 'Friends ({online} online of {total})',
  "Pas encore d'amis. Ajoute un joueur par son nom, ou clique sur lui dans le monde.":
    'No Friends yet. Add a player by name, or click on them in the world.',
  'En ligne': 'Online',
  'Hors ligne': 'Offline',
  // Away from the keyboard (ADR 0080)
  Absent: 'Away',
  'Absent · {place}': 'Away · {place}',
  'Tu es absent. Ta prochaine action te ramène.': 'You are away. Your next action brings you back.',
  Inviter: 'Invite',
  'Sûr ?': 'Sure?',
  Retirer: 'Remove',
  // ui/guild-client.ts
  "{from} t'invite dans la guilde {guild} [{tag}].":
    '{from} invites you to the Guild {guild} [{tag}].',
  "{name} n'est pas dans ta guilde.": '{name} is not in your Guild.',
  // ui/guild-panel.ts
  Chef: 'Leader',
  Officier: 'Officer',
  Membre: 'Member',
  "Tu n'es pas dans une guilde. Fonde la tienne, ou attends l'invitation d'un chef ou d'un officier.":
    'You are not in a Guild. Found your own, or wait for an invitation from a Leader or an Officer.',
  'Nom de la guilde': 'Guild name',
  'Tag (2 à 4 lettres)': 'Tag (2 to 4 letters)',
  'Fonder ({cost} or)': 'Found ({cost} gold)',
  'Devise de la guilde': 'Guild motto',
  '« {motto} »': '“{motto}”',
  'Aucune devise.': 'No motto.',
  Modifier: 'Edit',
  'Changer la devise': 'Change the motto',
  '{count} membres, {online} en ligne': '{count} Members, {online} online',
  '{count} membre, {online} en ligne': '{count} Member, {online} online',
  'Niv. {level}': 'Lv. {level}',
  Promouvoir: 'Promote',
  Rétrograder: 'Demote',
  Exclure: 'Kick',
  'Inviter un joueur': 'Invite a player',
  Quitter: 'Leave',
  Dissoudre: 'Disband',
  // ui/guild-text.ts
  'La guilde {name} est fondée.': 'The Guild {name} is founded.',
  'Invitation dans la guilde envoyée à {name}.': 'Guild invitation sent to {name}.',
  '{name} rejoint la guilde.': '{name} joins the Guild.',
  '{name} quitte la guilde.': '{name} leaves the Guild.',
  '{name} est exclu de la guilde.': '{name} is kicked from the Guild.',
  "{name} décline l'invitation dans la guilde.": '{name} declines the Guild invitation.',
  "{name} n'a pas répondu à l'invitation dans la guilde.":
    '{name} did not answer the Guild invitation.',
  '{name} est promu officier.': '{name} is promoted to Officer.',
  '{name} redevient simple membre.': '{name} is back to plain Member.',
  '{name} mène désormais la guilde.': '{name} now leads the Guild.',
  '{name} change la devise de la guilde.': '{name} changes the Guild motto.',
  'La guilde {name} est dissoute.': 'The Guild {name} is disbanded.',
  '{name} passe au niveau {level} !': '{name} reaches Level {level}!',
  'Demande refusée.': 'Request refused.',
  // ui/block-client.ts, ui/social-text.ts (ADR 0076)
  'Action refusée.': 'Action refused.',
  'Aucun joueur de ce nom.': 'No player by that name.',
  'Tu ne peux pas te bloquer toi-même.': 'You can’t block yourself.',
  'Ce joueur est déjà bloqué.': 'This player is already blocked.',
  "Ce joueur n'est pas bloqué.": 'This player isn’t blocked.',
  'Ta liste de joueurs bloqués est pleine.': 'Your blocked players list is full.',
  '{name} est bloqué : tu ne verras plus ses messages ni ses invitations.':
    '{name} is blocked: you won’t see their messages or invitations any more.',
  '{name} est débloqué.': '{name} is unblocked.',
  "{name} n'est pas bloqué.": '{name} isn’t blocked.',
  Bloquer: 'Block',
  Débloquer: 'Unblock',
  'Joueurs bloqués ({count})': 'Blocked players ({count})',
  'Tu ne peux pas faire ça avec toi-même.': 'You cannot do that with yourself.',
  'Ce joueur est déjà dans une guilde.': 'This player is already in a Guild.',
  "Tu es déjà dans une guilde. Quitte-la d'abord.": 'You are already in a Guild. Leave it first.',
  'Ton rang ne le permet pas.': 'Your rank does not allow it.',
  'La guilde est complète.': 'The Guild is full.',
  'Une invitation attend déjà sa réponse.': 'An invitation is already awaiting an answer.',
  "Cette invitation n'est plus valable.": 'This invitation is no longer valid.',
  "Ce joueur n'est pas dans ta guilde.": 'This player is not in your Guild.',
  "Tu n'as pas assez d'or pour fonder une guilde.": 'You do not have enough gold to found a Guild.',
  'Ce nom de guilde est déjà pris.': 'This Guild name is already taken.',
  'Ce tag est déjà pris.': 'This tag is already taken.',
  'Ce nom ou ce tag ne convient pas.': 'This name or tag is not allowed.',
  // ui/invite-prompt.ts
  Accepter: 'Accept',
  Refuser: 'Decline',
  // ui/kit.ts
  'Niveau {level}': 'Level {level}',
  // ui/loader.ts
  Chargement: 'Loading',
  // ui/minimap.ts
  'Portail de {name}': '{name} Portal',
  'niv. {level}': 'Lv. {level}',
  'niv. {min}-{max}': 'Lv. {min}-{max}',
  // ui/online-count.ts
  '{count} joueurs en ligne': '{count} players online',
  '{count} joueur en ligne': '{count} player online',
  // ui/party-frames.ts
  'Quitter le groupe': 'Leave the Party',
  Ailleurs: 'Elsewhere',
  'Exclure {name}': 'Kick {name}',
  // ui/ping-meter.ts
  'Ping : pas de réponse': 'Ping: no answer',
  'Ping : {ms} ms': 'Ping: {ms} ms',
  // ui/player-menu.ts (entries from ui/social-client.ts)
  'Inviter dans le groupe': 'Invite to Party',
  Inspecter: 'Inspect',
  'Message privé': 'Whisper',
  'Changer de canal (Tab)': 'Change channel (Tab)',
  'Changer de canal': 'Change channel',
  Canaux: 'Channels',
  'Ajouter en ami': 'Add Friend',
  Échanger: 'Trade',
  'Inviter dans la guilde': 'Invite to Guild',
  Signaler: 'Report',
  // ui/report-prompt.ts
  'Signaler {name}': 'Report {name}',
  Motif: 'Reason',
  'Ce qui s’est passé (facultatif)': 'What happened (optional)',
  Détails: 'Details',
  'Annuler (Échap)': 'Cancel (Esc)',
  // ui/social-client.ts
  "{name} t'invite dans son groupe.": '{name} invites you to their Party.',
  '{name} veut devenir ton ami.': '{name} wants to be your Friend.',
  'À qui ? Tape /m nom message.': 'To whom? Type /m name message.',
  "Personne ne t'a encore écrit.": 'No one has written to you yet.',
  // ui/inspect-panel.ts, scenes/world-scene.ts
  'Équipement de {name}': '{name}’s Equipment',
  '{slot} (apparence)': '{slot} (appearance)',
  'Ne porte rien.': 'Wears nothing.',
  "Ce joueur n'est plus près de toi.": 'That player is no longer near you.',
  "{name} n'est pas dans ton groupe.": '{name} is not in your Party.',
  'Commande inconnue : /{command}. {help}': 'Unknown command: /{command}. {help}',
  // ui/social-text.ts
  'Invitation envoyée à {name}.': 'Invitation sent to {name}.',
  '{name} rejoint le groupe.': '{name} joins the Party.',
  '{name} quitte le groupe.': '{name} leaves the Party.',
  '{name} est exclu du groupe.': '{name} is kicked from the Party.',
  "{name} décline l'invitation.": '{name} declines the invitation.',
  "{name} n'a pas répondu à l'invitation.": '{name} did not answer the invitation.',
  '{name} mène désormais le groupe.': '{name} now leads the Party.',
  'Le groupe est dissous.': 'The Party is disbanded.',
  'Ce joueur est déjà dans un groupe.': 'This player is already in a Party.',
  'Le groupe est complet.': 'The Party is full.',
  'Seul le chef du groupe peut faire ça.': 'Only the Party Leader can do that.',
  "Demande d'ami envoyée à {name}.": 'Friend request sent to {name}.',
  "{name} décline ta demande d'ami.": '{name} declines your Friend request.',
  "{name} n'a pas répondu à ta demande d'ami.": '{name} did not answer your Friend request.',
  '{name} est maintenant ton ami.': '{name} is now your Friend.',
  '{name} ne fait plus partie de tes amis.': '{name} is no longer one of your Friends.',
  '{name} vient de se connecter.': '{name} just came online.',
  'Tu ne peux pas être ton propre ami.': 'You cannot be your own Friend.',
  'Vous êtes déjà amis.': 'You are already Friends.',
  'Une demande attend déjà sa réponse.': 'A request is already awaiting an answer.',
  "La liste d'amis est pleine.": 'The Friends list is full.',
  "Cette demande n'est plus valable.": 'This request is no longer valid.',
  "Ce joueur n'est pas dans tes amis.": 'This player is not among your Friends.',
  // ui/sound-toggle.ts
  'Activer le son': 'Turn sound on',
  'Couper le son': 'Mute sound',
  Son: 'Sound',
  // ui/target-frame.ts
  '{name} · Niv. {level}': '{name} · Lv. {level}',
  Passif: 'Passive',
  Agressif: 'Aggressive',
  // ui/ladder-panel.ts
  Expérience: 'Experience',
  Serveur: 'Server',
  'Chargement…': 'Loading…',
  'Le classement ne répond pas. Réessaie dans un instant.':
    'The Leaderboard is not answering. Try again in a moment.',
  'Rejoins une guilde pour te mesurer à ses membres.':
    'Join a Guild to measure yourself against its members.',
  'Personne n’est encore classé.': 'Nobody is ranked yet.',
  '{count} aventuriers classés': '{count} adventurers ranked',
  // ui/touch-hud.ts
  Monture: 'Mount',
  Menu: 'Menu',
};
